import { useMe } from '@/features/auth/api'
import { hasPermission, type PermissionMode, type PermissionRequirement } from '@/lib/permissions'
import type { FeatureKey } from '@/types/api'

/** True when the current user holds the permission(s) in the current tenant. */
export function usePermission(required: PermissionRequirement, mode: PermissionMode = 'any'): boolean {
  const { data } = useMe()
  return hasPermission(data?.permissions, required, mode)
}

/** True when the current plan includes the feature. */
export function useFeature(feature: FeatureKey): boolean {
  const { data } = useMe()
  return data?.subscription?.entitlements.features[feature] === true
}
